import React, {useState, useEffect} from "react";
//import { Link } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/admin/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import {Link, useHistory, useLocation} from 'react-router-dom';
import StringUtil from "utils/StringUtil";
import CommonUtil from 'utils/CommonUtil';
import UI from "components/UI";
import UIUtils from "utils/UIUtils";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import PageLoading from "../../../../components/loading";

function ContentsContainer() {
	const location = useLocation();
	const history = useHistory();
	const receivedData = (location.state as any)?.data;	
	const [PAY_CALL_YYYY ,setPAY_CALL_YYYY] = useState('');
	const [MODI_SEQ ,setMODI_SEQ] = useState('');
	const [BIZ_CD ,setBIZ_CD] = useState('');
	const [PAY_CALL_TITLE, setPAY_CALL_TITLE] = useState('');		
	const [PAY_CALL_CONT,setPAY_CALL_CONT] = useState('');
    const [uploadId, setUploadId] = React.useState("");
	const [REG_USERNM, setREG_USERNM] = useState('');
	const [REG_DATE, setREG_DATE] = useState('');
	const [fileValue] = useState(new TbComFile());    
	const [loadFinish,setLoadFinish] = useState(false);
	
    async function onClickModi() {
		var vPAY_CALL_YYYY = PAY_CALL_YYYY;
		var vPAY_CALL_TITLE = PAY_CALL_TITLE;
		var vREG_USERNM = REG_USERNM;
		var vREG_DATE = REG_DATE;
		var vPAY_CALL_CONT = PAY_CALL_CONT;
		var vMODI_SEQ = MODI_SEQ;
		var vBIZ_CD = BIZ_CD;
		var vuploadId = uploadId;
		
				
	    let dataToSend = {
			vPAY_CALL_YYYY,
			vPAY_CALL_TITLE,
			vREG_USERNM,
			vREG_DATE,
			vPAY_CALL_CONT,
			vMODI_SEQ,
			vBIZ_CD,
			vuploadId
		};

	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: './adm1403',
	      state: { data: dataToSend }
	    });

    };    
    
    
    async function onClickList() {
	    let dataToSend = {};
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: './adm1400',
	      state: { data: dataToSend }
	    });

    };    

    
    async function onClickDelete() {
		if(await UIUtils.confirm('삭제하시겠습니까?')){	
			const response:any = await CommonUtil.execute({
	            url:"adm_1402_d002",
	            data: {
					"PAY_CALL_YYYY": receivedData.vPAY_CALL_YYYY,
					"MODI_SEQ": receivedData.vMODI_SEQ,
					"BIZ_CD": receivedData.vBIZ_CD,
				}
	        })
	        .then((response: any) => {          
				UIUtils.alert('정상처리되었습니다.').then();
	            // @ts-ignore
	            onClickList();
			
	       	}).catch((error) => {
	        	CommonUtil.showAxiosError(error);
	        	return;
	        	
	    	});
	    	
		}
		
    };       

    
	async function initialize(){
		const response:any = await CommonUtil.execute({
            url:"adm_1402_r001",
            data: {
				"PAY_CALL_YYYY": receivedData.vPAY_CALL_YYYY,
				"MODI_SEQ": receivedData.vMODI_SEQ,
				"BIZ_CD": receivedData.vBIZ_CD,
			}
        })
        .then((response: any) => { 
			console.log(response);
			setPAY_CALL_TITLE(response.PAY_CALL_TITLE);	
			setPAY_CALL_CONT(response.PAY_CALL_CONT);
			setUploadId(response.UPLOADID);
			setREG_USERNM(response.PERSON_NM);
			setREG_DATE(response.REG_DATE);

			let vfileInfoList = response.FILE_INFO_LIST;

			if(vfileInfoList!= null){
				vfileInfoList?.forEach((item, index) => {
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(item.DWLD_ID);
					fileDetail.setFileDetailId(item.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(item.FILE_POLICY);
					fileDetail.setFileRpstr(item.FILE_RPSTR);
					fileDetail.setStrePath(item.STRE_PATH);
					fileDetail.setStreFileNm(item.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(item.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(item.FILE_EXTSN);
					fileDetail.setFileSize(Number(item.FILE_SIZE));
					fileDetail.setRegistDt(item.REGIST_DT);
					fileDetail.setRegistPsnNm(item.REGIST_PSN_NM);
			
					fileValue.putTbComFileMapngDetailList(fileDetail);
				})
			}
			setLoadFinish(true);
			
       	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	        
	    	
    }
	
			
	useEffect(() => {
		if(receivedData !==undefined){		
			setPAY_CALL_YYYY(StringUtil.defaultString(receivedData.vPAY_CALL_YYYY));
			setMODI_SEQ(StringUtil.defaultString(receivedData.vMODI_SEQ));
			setBIZ_CD(StringUtil.defaultString(receivedData.vBIZ_CD));
			initialize();
		}
		
		return () => {
			
		}

    },[])	

	if(!loadFinish)
		return (
			<PageLoading />
		)
	else	    	
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={0} lnbD1Idx={3}  lnbD2Idx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">지급 신청 안내 상세</h1>
					<form className="fo fo-col4" name="" action="" method="">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">지급신청안내년도</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={PAY_CALL_YYYY} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-2-5">
								<p className="fo-key">제목</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={PAY_CALL_TITLE} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">등록자</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={REG_USERNM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-2-5">
								<p className="fo-key">등록일시</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={REG_DATE} placeholder={''} readOnly={true} />
								</div>
							</div>							
							<div className="fo-item fo-m-1-5">
								<p className="fo-key">내용</p>
								<div className="fo-value">
									<div className="ta-view w100p">
										{/*
										<div
											dangerouslySetInnerHTML={{
												__html: PAY_CALL_CONT || "",
											}}
										/>
										*/}
										<UI.SunEditor value={PAY_CALL_CONT} displayOnly/>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-5">
								<p className="fo-key">첨부파일</p>
								<div className="fo-value">
									<div className='w100p'>
										<UI.FileDownload
											value={fileValue}
		                    				//attrs={{Width:"100%", ImgPreView: "1", Views: "thumbs"}}
		                    				className={'w100p'}
	                           			/>									 
									</div>
								</div>
							</div>
						</div>
					</form>
					<div className="hz-root hz-right hz-gap5 mb10">
						<Button color="gray-o" size="sm" onClick={onClickDelete}>삭제</Button>
						<Button color="pri-o" size="sm" onClick={onClickModi}>수정</Button>
						<Button color="gray-o" size="sm" onClick={onClickList}>목록</Button>
					</div>					

				</main>
			</div>
		</PageContainer>
	);
}
export default ContentsContainer;